import { render, staticRenderFns } from "./figura.vue?vue&type=template&id=0a2e142d&"
import script from "./figura.vue?vue&type=script&lang=js&"
export * from "./figura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports